namespace Solovis.Site.JumpBox {

  async function _getJumpBoxItems() {
    var portalServices = new Solovis.Portal.SitePortalServices();
    var links = await portalServices.rpc().invokeAndWait("~/JumpTo/GetJumpBoxLinks", { includeSeperators: true, });
    return links.result;
  }

  export async function getAvailableModuleList() {
    var items = await _getJumpBoxItems();
    return items.filter((item) => item.separator !== true);
  }

  export async function showJumpBox(jumpBoxElement) {
    $(jumpBoxElement).addClass("active");
    var links = await _getJumpBoxItems();
    var linkPanel = Solovis.UI.PopupLinkPanel.showLinks({
      offsetElement: jumpBoxElement,
      offsetRight: false,
      offsetBottom: true,
      fromRightEdge: false,
      links: links,
      close: function () {
        $(jumpBoxElement).removeClass("active");
      },
    });
  }
}